import { userService } from '../../helpers/authservice/user.service';
import router from '../../router/index'

const user = JSON.parse(localStorage.getItem('user'));
export const state = user
    ? { status: { loggeduser: true }, user }
    : { status: {}, user: null };

export const getters = {
    loggedIn(state) {
        return !!state.user
    },
}

export const actions = {
    // Logs in the user.
    // eslint-disable-next-line no-unused-vars
    login({ dispatch, commit }, { username, password }) {
        commit('loginRequest', { username });

        userService.login(username, password)
            .then(
                user => {
                    commit('loginSuccess', user);
                    router.push({ name: 'home', params: { login: true } });
                },
                error => {
                    commit('loginFailure', error);
                    dispatch('notification/error', error, { root: true });
                }
            );
    },
    // Logs in the user via SSO Azure (authorization code dari callback)
    loginSso({ dispatch, commit }, { code, nonce }) {
        commit('loginRequest', null);

        return userService.loginSso(code, nonce)
            .then(
                user => {
                    commit('loginSuccess', user);
                    router.push({ name: 'home', params: { login: true } });
                },
                error => {
                    commit('loginFailure', error);
                    dispatch('notification/error', error, { root: true });
                    router.push({ name: 'login' });
                }
            );
    },
    // Logout the user
    logout({ commit }) {
        userService.logout();
        commit('logout');
    },
};

export const mutations = {
    loginRequest(state, user) {
        state.status = { loggingIn: true };
        state.user = user;
    },
    loginSuccess(state, user) {
        state.status = { loggeduser: true };
        state.user = user;
    },
    loginFailure(state) {
        state.status = {};
        state.user = null;
    },
    logout(state) {
        state.status = {};
        state.user = null;
    }
};

